// extracted by mini-css-extract-plugin
var _1 = "avatar__ACQ9K";
var _2 = "avatarWrapper__H06DT";
var _3 = "documents__gvmuX";
var _4 = "profile__Ei_2v";
var _5 = "wrapper__NYWUf";
export { _1 as "avatar", _2 as "avatarWrapper", _3 as "documents", _4 as "profile", _5 as "wrapper" }
export default { "avatar": _1, "avatarWrapper": _2, "documents": _3, "profile": _4, "wrapper": _5 }
